<template>
  <div class="accounting_customerservicereclamationsearch">
    <h2 class="accounting_customerservicereclamationsearch-header fadein">Buchhaltung: Kundenservicereklamation</h2>
    <div class="accounting_customerservicereclamationsearch-subtitle fadein d100ms">
      Finde Daten über Kundenservicereklamation heraus
    </div>
    <div class="accounting_customerservicereclamationsearch-card fadein d200ms">
      <ContextMenu ref="contextMenu" :model="contextMenuItems" />
<Button
  v-if="claimFilterId"
  icon="pi pi-arrow-left"
  label="Zurück"
  class="mb-3"
  @click="resetClaimFilter"
/>

      <DataTable
  class="accounting_customerservicereclamationsearch-card-tabl"
  :size="size"
  :value="accounting_customerservicereclamationsearch"
  stripedRows
  paginator
  :rows="10"
  :loading="loading"
  v-model:filters="filters"
  :rowsPerPageOptions="[10, 25, 50, 100, 200]"
  :globalFilterFields="['supplier', 'order', 'article']"
  filterDisplay="menu"
  dataKey="id"
  :rowClass="rowClass" 
  @row-contextmenu="onRowRightClick"
>

        <template #empty> Es wurden keine Einträge gefunden. </template>
        <template #loading> Einträge werden geladen. Bitte warten. </template>

        <Column header="ABG?" style="width: 3rem;">
  <template #body="{ data }">
    <Checkbox
      :binary="true"
      :modelValue="!!(data.completeddate && data.completeddate.trim() !== '')"
      @change="onABGCheckboxToggle($event, data)"
    />
  </template>
</Column>

        <Column field="createdby" header="ERSTELLT VON"></Column>
        <Column field="date" header="AUFTRITTS DATUM"></Column>
        <Column field="completeddate" header="ABG DATUM"></Column>
        
        <Column field="supplier" header="LIEFERANT">
          <template #filter="{ filterModel, filterCallback }">
            <InputText 
              v-model="filters.supplier.value" 
              @input="filterCallback()" 
              class="accounting_customerservicereclamationsearch-filter-row"
              type="text" 
              placeholder="Nach LIEFERANT suchen"
            />
          </template>
        </Column>

        <Column field="order" header="BESTELLUNG">
          <template #filter="{ filterModel, filterCallback }">
            <InputText 
              v-model="filters.order.value" 
              @input="filterCallback()" 
              class="accounting_customerservicereclamationsearch-filter-row"
              type="text" 
              placeholder="Nach BESTELLUNG suchen"
            />
          </template>
        </Column>

        <Column field="article" header="ART. NR.">
          <template #filter="{ filterModel, filterCallback }">
            <InputText 
              v-model="filters.article.value" 
              @input="filterCallback()" 
              class="accounting_customerservicereclamationsearch-filter-row"
              type="text" 
              placeholder="Nach ARTIKEL suchen"
            />
          </template>
        </Column>

        <Column field="reason" header="GRUND">
          <template #body="{ data }">
            <span :class="getReasonClass(data.reason)">
              {{ data.reason }}
            </span>
          </template>
        </Column>
        
        <Column field="should" header="SOLL"></Column>
        <Column field="is" header="IST"></Column>
        <Column field="reklaausgang" header="REKLA-AUSGANG">
  <template #body="{ data }">
    <span :class="getReklaausgangClass(data.reklaausgang)">
      {{ data.reklaausgang }}
    </span>
  </template>
</Column>

        <Column field="accounting_action" header="BUCHHALTUNG">
          <template #body="{data}">
            <span :class="getAccountingClass(data.accounting_action)">
              {{ data.accounting_action }}
            </span>
          </template></Column>
        <Column field="comment" header="KOMMENTAR"></Column>
        <Column field="attachment" header="ANHÄNGE">
          <template #body="{ data }">
            <span>
              <a v-if="data.attachment" :href="data.attachment" target="_blank">Klicke Hier</a>
              <a v-if="!data.attachment" style="color: lightcoral;">Keine Anhänge</a>
            </span>
          </template></Column>
      </DataTable>
    </div>
  </div>
</template>

<script>
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import InputText from "primevue/inputtext";
import { FilterMatchMode } from "primevue/api";
import axios from "axios";
import { getAuth } from "firebase/auth";
import SelectButton from "primevue/selectbutton";
import Button from "primevue/button";
import { config } from "../../../assets/config.js";
import { useAuthStore } from "@/stores/auth.js";
import Dialog from 'primevue/dialog'
import FloatLabel from "primevue/floatlabel"
import InputSwitch from 'primevue/inputswitch'
import Dropdown from 'primevue/dropdown'
import ContextMenu from 'primevue/contextmenu';
import Checkbox from 'primevue/checkbox';
import { useRoute } from 'vue-router';

export default {
  components: {
    DataTable,
    Column,
    InputText,
    Button,
    SelectButton,
    Dialog,
    FloatLabel,
    InputSwitch,
    Dropdown,
    ContextMenu,
    Checkbox
  },

  data() {
    return {
      authStore: useAuthStore(),
      accounting_customerservicereclamationsearch: [],
      filters: {
        supplier: { value: "", matchMode: FilterMatchMode.CONTAINS },
        order: { value: "", matchMode: FilterMatchMode.CONTAINS },
        article: { value: "", matchMode: FilterMatchMode.CONTAINS },
      },
      loading: true,
      dialogOpen: false,
      size: "small",
      sizeOptions: [
        { label: "Klein", value: "small" },
        { label: "Normal", value: "normal" },
        { label: "Groß", value: "large" },
      ],
      date: null,
      supplier: null,
      order: null,
      article: null,
      reason: null,
      should: null,
      is: null,
      comment: null,
      displayName: null,
      selectedEntry: null,
  completeddate: null,
  attachment: null,
  reklaausgang: null,
  accounting_action: null,
  createdby: null,
  showaccounting_actionDropdown: false,
  reklaausgangOptions: [
    "Zurückgeschickt",
    "Outlet",
    "Eingelagert",
    "Nachgeliefert",
    "Ersatzlieferung",
    "Keine Antwort -> Kommentar",
    "Andere... -> Kommentar",
    "Buchhaltung"
  ],
  reasonOptions: [
    "Mengendifferenz",
    "Beschädigt",
    "Nicht geliefert",
    "Falsch geliefert",
    "Qualitätsdifferenz",
    "Backorderüberschreitung",
    "Andere... -> Kommentar",
  ],
  accounting_actionOptions: ["Rechnung", "Gutschrift"],
  claimFilterId: null,
contextEntry: null,
contextMenuItems: [
  {
    label: 'Kopiere Link (Kundenservice)',
    icon: 'pi pi-copy',
    command: () => {
      if (this.contextEntry) {
        const url = `${window.location.origin}/customerservice/claims?claim=${this.contextEntry.id}`;
        navigator.clipboard.writeText(url);
        this.$toast.add({
          severity: 'success',
          summary: 'Kopiert',
          detail: 'Kundenservice-Link kopiert!',
          life: 3000
        });
      }
    }
  },
  {
    label: 'Kopiere Link (Buchhaltung)',
    icon: 'pi pi-copy',
    command: () => {
      if (this.contextEntry) {
        const url = `${window.location.origin}/accounting/customerservice/claims?claim=${this.contextEntry.id}`;
        navigator.clipboard.writeText(url);
        this.$toast.add({
          severity: 'success',
          summary: 'Kopiert',
          detail: 'Buchhaltungs-Link kopiert!',
          life: 3000
        });
      }
    }
  }
],
    };
  },

  methods: {
    onABGCheckboxToggle(checked, entry) {
  this.setEntryCompleted({ data: entry, checked });
},
    async fetchData() {
  this.loading = true;
  try {
    const response = await axios.get(config.api_url + "/api/accounting/customerservice/search", {
      headers: {
        Authorization: await getAuth().currentUser.getIdToken(),
      },
    });

    let data = this.modifyData(response.data);

    // 🔁 Get token-based attachment URLs
    const tokenFetches = data.map(async (entry) => {
        await this.getAuthTokenAndUpdate(entry);
    });

    this.accounting_customerservicereclamationsearch = data.sort((a, b) => {
  const parse = (d) => {
    if (!d || typeof d !== "string" || d.trim() === "") return null;
    const parts = d.split(".");
    return new Date(parts[2], parts[1] - 1, parts[0]); // dd.mm.yyyy → Date
  };

  const dateA = parse(a.date);
  const dateB = parse(b.date);
  const completedA = parse(a.completeddate);
  const completedB = parse(b.completeddate);

  // 1. If only A has completeddate, B comes first
  if (completedA && !completedB) return 1;
  if (!completedA && completedB) return -1;

  // 2. If neither has completeddate, sort by date (desc)
  if (!completedA && !completedB) return dateB - dateA;

  // 3. If both have completeddate, sort by completeddate (desc)
  return completedB - completedA;
});

    await Promise.all(tokenFetches);

    // 🔍 Optional filtering by claim
    if (this.claimFilterId) {
      data = data.filter(entry => entry.id === this.claimFilterId);
    }

    this.accounting_customerservicereclamationsearch = data;

    this.accounting_customerservicereclamationsearch.sort((a, b) => {
      const dateA = this.parseDate(a.date);
      const dateB = this.parseDate(b.date);
      const completedDateA = a.completeddate ? this.parseDate(a.completeddate) : null;
      const completedDateB = b.completeddate ? this.parseDate(b.completeddate) : null;

      if (!completedDateA && completedDateB) return -1;
      if (completedDateA && !completedDateB) return 1;
      if (!completedDateA && !completedDateB) return dateB - dateA;
      return completedDateB - completedDateA;
    });
  } catch (error) {
    console.error("❌ Fetch error:", error);
  } finally {
    this.loading = false;
  }
},
async getAuthTokenAndUpdate(entry) {
  if(!entry.attachment) {return;}
  try {
    const res = await axios.get(`${config.api_url}/api/customerservice/reclamationsearch/getToken/${entry.id}`, {
      headers: {
        Authorization: await getAuth().currentUser.getIdToken()
      }
    });

    if (res.status === 200 && res.data.token) {
      entry.attachment = `${config.api_url}/customerservice/reclamationsearch/creditnote/${entry.id}/${res.data.token}`;
    } else if (res.status === 404) {
      entry.attachment = null

      return;
    }
  } catch (err) {
    if (err.response?.status === 404) {
      entry.attachment = null
      return;
    }
    console.error(`❌ Token fetch failed for entry ${entry.id}`, err);
  }
},




resetClaimFilter() {
  this.$router.push('/accounting/customerservice/claims');
  this.claimFilterId = null;
  this.fetchData();
},

onRowRightClick(event) {
  const now = new Date().getTime();
  const timeSinceLastClick = now - (this.lastRightClickTime || 0);

  // First click → allow default context menu
  if (timeSinceLastClick >= 500) {
    this.lastRightClickTime = now;
    return; // Let browser handle it
  }
  event.originalEvent.preventDefault();
  this.contextEntry = event.data;


  if (this.contextEntry && this.contextEntry.id) {
    this.$refs.contextMenu.show(event.originalEvent);
  }
},

parseDate(dateStr) {
  if (!dateStr) return null;
  const parts = dateStr.split(".");
  return new Date(parts[2], parts[1] - 1, parts[0]); 
},
rowClass(data) {
  const today = new Date();
  const oneWeekAgo = new Date();
  oneWeekAgo.setDate(today.getDate() - 7);

  if (!data.completeddate && new Date(data.date) < oneWeekAgo) {
    return 'row-red';
  }
  return '';
},
getReasonClass(reason) {
  const colors = {
    "Mengendifferenz": "reason-red",
    "Beschädigt": "reason-darkred",
    "Nicht geliefert": "reason-lightred",
    "Falsch geliefert": "reason-purple",
    "Qualitätsdifferenz": "reason-blue",
    "Backorderüberschreitung": "reason-teal",
    "Andere... -> Kommentar": "reason-white"
  };

  return colors[reason] || "";
},

getAccountingClass(type) {
  const colors = {
    "Rechnung": "reason-darkred",
    "Gutschrift": "rekla-darkgreen",
  };

  return colors[type] || "";
},

getReklaausgangClass(reklaausgang) {
  const colors = {
    "Zurückgeschickt": "rekla-green",
    "Outlet": "rekla-purple",
    "Eingelagert": "rekla-darkgreen",
    "Nachgeliefert": "rekla-yellow",
    "Ersatzlieferung": "rekla-orange",
    "Keine Antwort -> Kommentar": "rekla-red",
    "Andere... -> Kommentar": "rekla-white"
  };

  return colors[reklaausgang] || "";
},

    modifyData(data) {
      return data.map((entry) => ({
        ...entry,
        date: this.formatDate(entry.date),
        completeddate: this.formatDate(entry.completeddate),
      }));
    },

    formatDate(dateStr) {
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return dateStr;
      return date.toLocaleDateString("de-DE");
    },
    async setEntryCompleted(event) {
      const { data, checked } = event;
      this.selectedEntry = event.data
      this.loading = true;

      if (!this.selectedEntry.completeddate) {
        const url = checked
      ? `${config.api_url}/api/accounting/customerservice/check/${data.id}`
      : `${config.api_url}/api/accounting/customerservice/uncheck/${data.id}`;
      try {
      let response;
        response = await axios.get(url, {
        headers: { Authorization: await getAuth().currentUser.getIdToken() }
      });

    if (response.status === 201 || response.status === 200) {
      this.$toast.add({
        severity: 'success',
        summary: 'Eintrag als abgeschlossen markiert',
        group: "tc",
        detail: 'Der Eintrag wurde erfolgreich abgeschlossen.',
        life: 5000
      });
      this.selectedEntry = null;
      this.fetchData();
    }
  } catch (error) {
    if (error.response.status === 401) {
      this.$toast.add({
        severity: 'error',
        summary: 'Keine Berechtigung',
        group: "tc",
        detail: 'Du hast keine Berechtigung das zu tun!',
        life: 5000
      });

      this.fetchData();
      return
    }
    console.error("❌ [ERROR] API request failed:", error);
    this.$toast.add({
      severity: 'error',
      summary: 'Fehler',
      group: "tc",
      detail: 'Fehler beim Speichern des Eintrags.',
      life: 5000
    });
  } finally {
    this.loading = false;
  }
  } else {
    try {
    let response;
      response = await axios.get(config.api_url + '/api/accounting/customerservice/uncheck/' + this.selectedEntry.id, {
        headers: { Authorization: await getAuth().currentUser.getIdToken() }
      });

    if (response.status === 201 || response.status === 200) {
      this.$toast.add({
        severity: 'success',
        summary: 'Eintrag als nicht mehr abgeschlossen markiert',
        group: "tc",
        detail: 'Der Eintrag wurde als nicht abgeschlossen markiert.',
        life: 5000
      });

      this.fetchData();
    }
  } catch (error) {
    if (error.response.status === 401) {
      this.$toast.add({
        severity: 'error',
        summary: 'Keine Berechtigung',
        group: "tc",
        detail: 'Du hast keine Berechtigung das zu tun!',
        life: 5000
      });

      this.fetchData();
      return
    }
    console.error("❌ [ERROR] API request failed:", error);
    this.$toast.add({
      severity: 'error',
      summary: 'Fehler',
      group: "tc",
      detail: 'Fehler beim Speichern des Eintrags.',
      life: 5000
    });
  } finally {
    this.loading = false;
  }
  }
},
  },

  mounted() {
      const route = useRoute();
  const claimId = route.query.claim;
  if (claimId) {
    this.claimFilterId = parseInt(claimId);
  }
    this.fetchData();
  },
  watch: {
  reklaausgang(newVal) {
    this.showaccounting_actionDropdown = ["accounting_action", "Andere... -> Kommentar"].includes(newVal);
  }
}
};
</script>

<style lang="scss" scoped>
.accounting_customerservicereclamationsearch {
  &-filter-row {
    display: flex;
    align-items: flex-start;
    max-width: 15rem;
  }

  &-header {
    margin-bottom: 0;
  }

  &-subtitle {
    color: rgb(192, 192, 192);
  }

  &-card {
    margin-top: 2rem;
    border-radius: 1rem;
    padding: 1rem;
    background-color: var(--surface-0);
  }
}

/* 🔹 Modal Styling */
.cua-modal {
  padding: 1.5rem;
  background-color: var(--surface-800);
  border-radius: 0.75rem;
}

.cua-modal-text {
  font-size: 1.2rem;
  font-weight: bold;
  color: white;
  margin-bottom: 1rem;
  display: block;
}

/* 🔹 Fix FloatLabel Spacing */
.cua-modal-inputs FloatLabel {
  display: block;
  margin-bottom: 1.2rem; /* Ensures spacing between fields */
}

/* 🔹 Standard Button & Input Styles */
.cua-modal-btn {
  width: 100%;
  height: 2.5rem;
  font-size: 1rem;
  border-radius: 0.5rem;
}

/* 🔹 Fix Dropdown Size to Match Input Fields */
.p-dropdown {
  width: 100%;
  height: 2.5rem;
}

/* 🔹 Ensure Buttons Align Correctly */
.cua-modal-btns {
  display: flex;
  justify-content: space-between; /* Buttons appear side by side */
  gap: 1rem; /* Adds spacing between buttons */
  margin-top: 1rem;
}

/* 🔹 Hide Rekla-Ausgang & accounting_action on New Entry */
[v-cloak] {
  display: none;
}

/* 🔹 Red rows for outdated claims */
.row-red {
  background-color: #ffcccc !important; /* Light red background */
}

/* 🔹 Reason Colors */
.reason-red {
  background-color: #ff5733 !important;
  color: white;
  padding: 5px;
  border-radius: 5px;
}

.reason-darkred {
  background-color: #d32f2f !important;
  color: white;
  padding: 5px;
  border-radius: 5px;
}

.reason-lightred {
  background-color: #ff1744 !important;
  color: white;
  padding: 5px;
  border-radius: 5px;
}

.reason-purple {
  background-color: #8e24aa !important;
  color: white;
  padding: 5px;
  border-radius: 5px;
}

.reason-blue {
  background-color: #1976d2 !important;
  color: white;
  padding: 5px;
  border-radius: 5px;
}

.reason-teal {
  background-color: #009688 !important;
  color: white;
  padding: 5px;
  border-radius: 5px;
}

.reason-white {
  background-color: #ffffff !important;
  color: black;
  padding: 5px;
  border-radius: 5px;
}

/* 🔹 Reklaausgang Colors */
.rekla-green {
  background-color: #b7e1a1 !important;
  color: black;
  padding: 5px;
  border-radius: 5px;
}

.rekla-purple {
  background-color: #4a148c !important;
  color: white;
  padding: 5px;
  border-radius: 5px;
}

.rekla-darkgreen {
  background-color: #388e3c !important;
  color: white;
  padding: 5px;
  border-radius: 5px;
}

.rekla-yellow {
  background-color: #ffeb3b !important;
  color: black;
  padding: 5px;
  border-radius: 5px;
}

.rekla-orange {
  background-color: #ff9800 !important;
  color: black;
  padding: 5px;
  border-radius: 5px;
}

.rekla-red {
  background-color: #d32f2f !important;
  color: white;
  padding: 5px;
  border-radius: 5px;
}

.rekla-white {
  background-color: #ffffff !important;
  color: black;
  padding: 5px;
  border-radius: 5px;
}

::v-deep(.p-datatable-striped .p-datatable-tbody > tr:nth-child(even)) {
  background-color: #464646 !important; // light grey
}
</style>
